export default __webpack_public_path__ + "static/media/city.84ff8d13.webp";